import React from 'react';
import { styled } from '@linaria/react';

import Spacer from '@/components/Spacer';
import Toggle from '@/components/Toggle';

interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
  active: boolean;
  handleToggle: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
}

function ToggleButton({
  active,
  handleToggle,
  children,
  ...delegated
}: Props) {
  const id = React.useId();

  return (
    <Wrapper htmlFor={id} {...delegated}>
      <Toggle
        id={id}
        active={active}
        handleToggle={handleToggle}
        handleFocusColor={null}
        handleColor={
          active ? 'var(--color-text)' : 'var(--color-gray-400)'
        }
      />
      <Spacer size={16} />
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  font-size: 1rem;
  padding: 8px 16px;
  padding-right: 20px;
  border-radius: 4px;
  border: 1px solid var(--color-gray-200);
  cursor: pointer;
  /*
  Clicking the text to toggle the perspective causes the text
  to become selected. This is distracting.
*/
  user-select: none;
`;

export default ToggleButton;
